import { Component, input, output } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { NExpeRowData } from '../../nexpe.model';

@Component({
  selector: 'app-nexpe-table',
  imports: [TranslateModule],
  templateUrl: './nexpe-table.component.html',
  styleUrl: './nexpe-table.component.scss',
})
export class NexpeTableComponent {
  nexpes = input.required<NExpeRowData[]>();
  rowClick = output<string>();

  onRowClick(nexpeId: string): void {
    this.rowClick.emit(nexpeId);
  }
}
